export default function (state = {email: "youremail@dsn.com"}, action) {
    switch (action.type) {
        case 'Customer_Email':
            return {
              email: action.email
            };
            break;
        default:
          return state;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/config/allReducers/general/customer_email.js